import {createApp, reactive} from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import '@/assets/css/styles.css'


import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'swiper/swiper-bundle.css';
import ToastService from 'primevue/toastservice';
import AutoComplete from 'primevue/autocomplete';
import Button from "primevue/button";
import Calendar from 'primevue/calendar';
import Card from 'primevue/card';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';   // optional
import ConfirmDialog from 'primevue/confirmdialog';
import DataTable from 'primevue/datatable';
import DatePicker from 'primevue/calendar';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Row from 'primevue/row';
import Select from 'primevue/selectbutton';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Toast from "primevue/toast";
import Toolbar from 'primevue/toolbar';
import PrimeVue from 'primevue/config';
import ToggleSwitch from 'primevue/togglebutton';

import i18n from "@/utils/i18n"

const options = {
    confirmButtonColor: '#FFD000',
    cancelButtonColor: '#B81A12',
};


const app = createApp(App);

app.component('ToggleSwitch', ToggleSwitch);
app.component('AutoComplete', AutoComplete);
app.component('Button', Button);
app.component('Calendar', Calendar);
app.component('Card', Card);
app.component('Column', Column);
app.component('ColumnGroup', ColumnGroup);
app.component('ConfirmDialog', ConfirmDialog);
app.component('DataTable', DataTable);
app.component('DatePicker', DatePicker);
app.component('Dialog', Dialog);
app.component('InputText', InputText);
app.component('InputNumber', InputNumber);
app.component('Row', Row);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);
app.component('Toast', Toast);
app.component('Toolbar', Toolbar);
app.component('Select', Select)
app.use(router);
app.use(VueSweetalert2, options);
app.use(ToastService);
app.use(i18n);
const state = reactive({
    loading: false,
    userId: 0,
    logged: false,
    name: "",
    perfilId: 0,
    region: "",
    celular: "",
    whatsapp: false,
    reference_id: "",
    negocio_id: ""
})

app.use(PrimeVue, {ripple: true});
app.provide(/* key */ 'rootScope', /* value */ state);
app.mount('#app');


